(function(angular){
	'use strict';
	
	angular
		.module('recurringInvestmentAgreementsModule',
		[
			'agreementsModule',
			'apiModule',
			'coreModule',
			'formValidationModule',
			'progressIndicatorModule'
		]);
	
})(window.angular);